import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: "app-webform",
    template: `
    <p>Redirecting to secure.icuregswe.org...</p>
    `,
    standalone: false
})
export class WebformComponent {
    private router = inject(Router);


    constructor() {
        this.router.navigate([""]);
    }

}
